const insertAnElementIntoArrayAtSpecificIndex = (array, index, element) => {
  if (!index) {
    index = array.length;
  }
  return [...array.slice(0, index - 1), element, ...array.slice(index - 1, array.length)];
};

export default insertAnElementIntoArrayAtSpecificIndex;
